var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-2-columns",class:[_vm.smallerGap ? 'smaller-gap' : '']},[_c('div',[(_vm.swapColumns)?_vm._t("second"):_vm._t("first")],2),_vm._v(" "),_c('div',[(_vm.swapColumns)?_vm._t("first"):_vm._t("second")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }